import React, { useState } from 'react';
import './RoomsGallery.css';
import ImageVideoSlider from './ImageVideoSlider';

interface BaseMediaItem {
  type: 'image' | 'video' | 'youtube';
  thumbnail: string;
}

interface ImageVideoMediaItem extends BaseMediaItem {
  type: 'image' | 'video';
  url: string;
}

interface YoutubeMediaItem extends BaseMediaItem {
  type: 'youtube';
  youtubeId: string;
}

type MediaItem = ImageVideoMediaItem | YoutubeMediaItem;

interface Room {
  id: number;
  title: string;
  description: string;
  coverImage: string;
  media: MediaItem[];
}

interface RoomsGalleryProps {
  content: {
    title: string;
    rooms: Room[];
  };
}

const RoomsGallery: React.FC<RoomsGalleryProps> = ({ content }) => {
  const [selectedRoom, setSelectedRoom] = useState<Room | null>(null);
  const [isOpening, setIsOpening] = useState(false);

  const handleRoomClick = (room: Room) => {
    setSelectedRoom(room);
    setIsOpening(true);
    // Reset the opening state after animation
    setTimeout(() => setIsOpening(false), 300);
  };

  return (
    <div className="rooms-section">
      <div className="section-header">
        <h2>{content.title}</h2>
      </div>
      
      <div className="rooms-grid">
        {content.rooms.map((room, index) => (
          <div 
            key={room.id} 
            className={`room-item layout-${index % 5 + 1}`}
            onClick={() => handleRoomClick(room)}
          >
            <div 
              className="room-cover" 
              style={{ backgroundImage: `url(${room.coverImage})` }}
            >
              <div className="room-info">
                <h3>{room.title}</h3>
                <p>{room.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedRoom && (
        <ImageVideoSlider
          media={selectedRoom.media}
          title={selectedRoom.title}
          onClose={() => setSelectedRoom(null)}
          isOpening={isOpening}
        />
      )}
    </div>
  );
};

export default RoomsGallery; 